module.exports = __webpack_public_path__ + "img/Ratings.4004895b.svg";